import React, { useEffect, useState, useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DesmosCalculatorWindow = ({ onClose }) => {
  const [position, setPosition] = useState({ x: 120, y: 120 });
  const draggingRef = useRef(false);
  const offsetRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!draggingRef.current) return;

      setPosition({
        x: e.clientX - offsetRef.current.x,
        y: e.clientY - offsetRef.current.y,
      });
    };

    const handleMouseUp = () => {
      draggingRef.current = false;
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const handleMouseDown = (e) => {
    draggingRef.current = true;
    offsetRef.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: position.y,
        left: position.x,
        width: 400,
        height: 600,
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0px 8px 24px rgba(0,0,0,0.25)",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* HEADER / DRAG HANDLE */}
      <Box
        onMouseDown={handleMouseDown}
        sx={{
          height: 44,
          backgroundColor: "#000",
          display: "flex",
          alignItems: "center",
          px: 1.5,
          cursor: "grab",
          userSelect: "none",
          position: "relative", // needed for absolute centering
        }}
      >
        {/* LEFT: Title */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: "#fff",
          }}
        >
          Calculator
        </Typography>

        {/* CENTER: 6-dot drag handle (absolute true center) */}
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            display: "grid",
            gridTemplateColumns: "repeat(3, 4px)",
            gridTemplateRows: "repeat(2, 4px)",
            gap: "4px",
            pointerEvents: "none", // drag still works from header
          }}
        >
          {Array.from({ length: 6 }).map((_, i) => (
            <Box
              key={i}
              sx={{
                width: 4,
                height: 4,
                borderRadius: "50%",
                backgroundColor: "#fff",
                opacity: 0.9,
              }}
            />
          ))}
        </Box>

        {/* RIGHT: Close */}
        <Box sx={{ marginLeft: "auto" }}>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" sx={{ color: "#fff" }} />
          </IconButton>
        </Box>
      </Box>

      {/* DESMOS */}
      <Box sx={{ flexGrow: 1 }}>
        <iframe
          src="https://www.desmos.com/testing/cb-sat-ap/graphing"
          title="Desmos Calculator"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Box>
    </Box>
  );
};

export default DesmosCalculatorWindow;
